'use client';

import * as React from 'react';
import { useAtomValue } from 'jotai';
import { heroAtom } from '../../_components/design-state';

export function BlogHero(): JSX.Element {
  const hero = useAtomValue(heroAtom);
  return (
    <section className="home-hero">
      <div
        id="hero"
        dangerouslySetInnerHTML={{ __html: hero }}
        className="home-hero-content"
      />
    </section>
  );
}
